import { Inject, Injectable } from '@angular/core';
import { FirebaseApp } from 'firebase/app';
import { CONFERENCES_COLLECTION_PATH, CONFERENCE_REGISTRANTS_COLLECTION_PATH } from 'ag-common-svc/public-api';
import { EMAIL_CAMPAIGN_PATH, ConferenceRegistrationCampaignEmail } from '@ag-common-lib/public-api';
import { FIREBASE_APP } from 'ag-common-svc/lib/injections/firebase-app';
import { CommonFireStoreDao, QueryParam } from 'ag-common-svc/lib/dao/CommonFireStoreDao.dao';
import { Observable } from 'rxjs';

@Injectable()
export class ConferenceRegistrationEmailCampaignService<ConferenceRegistrationCampaignEmail> {
  protected readonly fsDao: CommonFireStoreDao<ConferenceRegistrationCampaignEmail>;

  constructor(@Inject(FIREBASE_APP) fireBaseApp: FirebaseApp) {
    this.fsDao = new CommonFireStoreDao<ConferenceRegistrationCampaignEmail>(fireBaseApp, null, null);
  }

  getList(
    conferenceDbId: string,
    registrantDbId: string,
    qp?: QueryParam[],
  ): Observable<ConferenceRegistrationCampaignEmail[]> {
    const table = [CONFERENCES_COLLECTION_PATH, conferenceDbId, CONFERENCE_REGISTRANTS_COLLECTION_PATH, registrantDbId]
      .filter(Boolean)
      .join('/');
    return this.fsDao.getList(table, qp);
  }

  sendEmailToRegistrant(
    conferenceDbId: string,
    registrantDbId: string,
    data: ConferenceRegistrationCampaignEmail,
  ): Promise<void | ConferenceRegistrationCampaignEmail> {
    const table = ConferenceRegistrationEmailCampaignService.getCollectionPath(conferenceDbId, registrantDbId);

    return this.fsDao.create(data, table);
  }

  static getCollectionPath(conferenceDbId: string, registrantDbId: string) {
    return [
      CONFERENCES_COLLECTION_PATH,
      conferenceDbId,
      CONFERENCE_REGISTRANTS_COLLECTION_PATH,
      registrantDbId,
      EMAIL_CAMPAIGN_PATH,
    ].join('/');
  }
}
